<template>
    <the-btn
        :text="text"
        :btnClass="'btn btn-outline-custom btn-sm'"
        @click.native="onClick"
        :disabled="disabled"
    ></the-btn>

</template>

<script>
export default {
    props: {
        onClick: {
            type: Function,
            default: () => {}
        },
        text: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
